import { AlertTriangle } from 'lucide-react'

/**
 * Pure empty state shown when the document has no Parquet preview yet (still
 * being processed by the ingestion pipeline).
 */
export function ParquetUnavailable() {
  return (
    <div className="flex-1 flex items-center justify-center text-sm text-muted-foreground gap-2">
      <AlertTriangle className="h-4 w-4" />
      This file is still being processed. Parquet preview is not yet available.
    </div>
  )
}
